import React, {useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TrashIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';

import CustomDialog from '../common/CustomDialog';

import {formatDate, formatTime} from '../../helpers/dates';
import {useRemoveEventMutation} from '../../redux/services/eventApi';

const getTimeText = (rawTime, isRecurring) => {
  if (!isRecurring) return formatDate(rawTime) + ' ' + formatTime(rawTime);
  const time = rawTime.replace(/\:00$/, '');
  // change from 24-hour time (like 24:00) to 12-hour time (like 12:00 AM)
  const [hour, minute] = time.split(':');
  const hourNum = parseInt(hour);
  const ampm = hourNum >= 12 ? 'PM' : 'AM';
  const hour12 = hourNum % 12 === 0 ? 12 : hourNum % 12;
  return `${hour12}:${minute} ${ampm}`;
};

const handleRemove = ({remove, afterDelete, event}) => async () => {
  const response = await remove({id: event.id});
  if (response?.data?.success) afterDelete();
};


const EventDetails = ({ event, afterDelete }) => {
  const [remove, response] = useRemoveEventMutation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (!event) return null;
  if (response.isSuccess) {
    return (
      <Stack alignItems='center' spacing={2} padding={4}>
        <Typography variant='h4'>✅ Deleted Event</Typography>
      </Stack>
    );
  }

  const start_time = event.is_recurring ? event.recurring_start_time : event.start_time;
  const end_time = event.is_recurring ? event.recurring_end_time : event.end_time;
  const startTimeText = getTimeText(start_time, event.is_recurring);
  const endTimeText = getTimeText(end_time, event.is_recurring);
  console.log('EVENTDETAILS', event);
  return (
    <Box>
      <Grid container spacing={2}>
        {!!event?.title && [
          <Grid item xs={6} md={3}>
            <strong>Title:</strong>
          </Grid>
          , <Grid item xs={6} md={9}>
            {event.title}
          </Grid>
      ]}
        <Grid item xs={6} md={3}>
          <strong>Event Type:</strong>
        </Grid>
        <Grid item xs={6} md={9}>
          {event.event_category === 'AWAY_TIME' ? 'Away Time' : 'Meeting & Marketing Time'}
        </Grid>
        <Grid item xs={6} md={3}>
          <strong>Start Time:</strong>
        </Grid>
        <Grid item xs={6} md={9}>
          {startTimeText}
        </Grid>
        <Grid item xs={6} md={3}>
          <strong>End Time:</strong>
        </Grid>
        <Grid item xs={6} md={9}>
          {endTimeText}
        </Grid>
        {event.is_recurring && [
          <Grid item xs={6} md={3}>
            <strong>Repeats on Days:</strong>
          </Grid>
          , <Grid item xs={6} md={9}>
            {event.recurring_days?.join(', ') || 'N/A'}
          </Grid>,
          <Grid item xs={6} md={3}>
            <strong>Repeats every:</strong>
          </Grid>,
          <Grid item xs={6} md={9}>
            {event?.repeat_every_period_value} weeks
          </Grid>
        ]}
        <Grid item xs={12} alignItems='center'>
          <Button
            color='error'
            startIcon={<TrashIcon/>}
            onClick={() => setConfirmOpen(true)}
          >
            Delete Event
          </Button>
        </Grid>
      </Grid>
      <CustomDialog
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        title='Delete Event'
        maxWidth='xs'
        actionButtons={[
          () => <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>,
          () => <Button color='error' onClick={handleRemove({remove, afterDelete, event})}>Delete</Button>,
        ]}
      >
        <Typography>Are you sure you want to delete this event?</Typography>
      </CustomDialog>
    </Box>
  );
};

export default EventDetails;